import React from 'react';

import Input from '../../../../../../../common/data-entry/Input';

import './CellTextField.scss';

export function CellTextField({ value, onChange, placeholder, maxLength }) {
  return (
    <div className="eui-table-input">
      <Input placeholder={placeholder} legacyLook={true} onChange={onChange} value={value} maxLength={maxLength} />
    </div>
  );
}
